const history = {
  actions: [],
  undo: [],
  buffer: null
}

export default {
  enabled: true,
  reset: function () {
    history.actions = []
    history.undo = []
    history.bufer = null
    this.enabled = true
  },
  add: function (object) {
    if (!this.enabled) {
      return
    }
    history.actions.unshift({ actionKey: object.actionKey, objectKey: object.key })
    history.undo = []
  },
  performed: function (object) {
    let found = false
    history.actions.forEach((action) => {
      if (action.actionKey === object.actionKey) {
        found = true
      }
    })

    return found
  },
  get: function () {
    return history
  },
  last: function () {
    if (history.actions.length > 0) {
      return history.actions[0]
    }
    return null
  },
  lastUndo: function () {
    if (history.undo.length > 0) {
      return history.undo[0]
    }
    return null
  },
  undo: function () {
    history.undo.unshift(history.actions.shift())
  },
  redo: function () {
    history.actions.unshift(history.undo.shift())
  },
  copy: function (object) {
    history.buffer = object
  },
  paste: function (customProperties) {
    if (history.buffer) {
      const current = history.buffer
      history.buffer.clone((o) => {
        history.buffer = o
      }, customProperties)
      return current
    }
  },
  isDirty: function () {
    return history.actions.length > 0
  }
}
